import type { auth as en } from '@/i18n/locales/en/auth';
import type { Translation } from '@/i18n/types';

export const auth: Translation<typeof en> = {
  signInFailed: 'Anmeldung fehlgeschlagen',
  checkingSession: 'Deine Sitzung wird überprüft…',
  redirectingToSignIn: 'Weiterleitung zur Anmeldung…',
  signingIn: 'Du wirst angemeldet…',
  backToDashboard: 'Zurück zum Dashboard',
};
